var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrinter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.99 3A3.003 3.003 0 0 1 16 5.997v6.006A2.996 2.996 0 0 1 12.99 15l-1.258.001-.052.085a1.99 1.99 0 0 1-1.678.914H5.998c-.702 0-1.32-.359-1.676-.909l-.072-.12.017.03L3.009 15A3.003 3.003 0 0 1 0 12.003V5.997A2.996 2.996 0 0 1 3.01 3zM11 10H5v4c0 .556.444 1 .99 1h4.02a1 1 0 0 0 .99-1zm-1 3v1H6v-1zm0-2v1H6v-1zm3-5h-2v2h2zm-1.997-6c.55 0 .997.444.997 1v1H4V1c0-.552.453-1 .997-1z"
})));
export default SvgPrinter;